var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(_setup.BaseLayersTreeItem, { attrs: { item: _vm.item } }, [
    _c("div", { staticClass: "layer-row pl-2" }, [
      _c("div", { staticClass: "grow-1 d-flex items-center pr-2" }, [
        !_setup.flags?.isDesign && !_setup.flags?.readonly
          ? _c("div", { staticClass: "d-flex items-center pr-3" }, [
              _setup.canChangeElementVisibility
                ? _c(
                    "div",
                    {
                      staticClass: "action cursor-pointer no-drag",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _setup.onLayerVisibilityClick.apply(
                            null,
                            arguments
                          )
                        },
                      },
                    },
                    [
                      _setup.isVisible
                        ? _c("font-awesome-icon", {
                            staticClass: "mr-1 action-icon",
                            attrs: { icon: ["far", "eye"] },
                          })
                        : _c("font-awesome-icon", {
                            staticClass: "mr-1 action-icon",
                            attrs: { icon: ["fas", "eye-slash"] },
                          }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _setup.canChangeElementLock
                ? _c(
                    "div",
                    {
                      staticClass: "action cursor-pointer no-drag",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _setup.onLayerLockClick.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _setup.isLocked ||
                      (!_setup.isPreviewStep && _setup.isElementSolidBackground)
                        ? _c("font-awesome-icon", {
                            staticClass: "mr-1 action-icon",
                            attrs: { icon: ["fas", "lock"] },
                          })
                        : _c("font-awesome-icon", {
                            staticClass: "mr-1 action-icon",
                            attrs: { icon: ["far", "lock-open"] },
                          }),
                    ],
                    1
                  )
                : _vm._e(),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex pr-1 items-center w-full" }, [
          _vm.item.element.isOverlay
            ? _c(
                "div",
                { staticClass: "mr-2" },
                [
                  _c("font-awesome-icon", {
                    staticClass: "mr-1 status-icon",
                    attrs: { icon: ["far", "clone"] },
                  }),
                ],
                1
              )
            : _vm.item.element.isPrintArea
            ? _c(
                "div",
                { staticClass: "mr-2" },
                [
                  _c("font-awesome-icon", {
                    staticClass: "mr-1 status-icon",
                    attrs: { icon: ["far", "print"] },
                  }),
                ],
                1
              )
            : _vm.item.element.type === "image-placeholder" &&
              _vm.item.element.dynamicImagesPath &&
              _vm.item.element.isColorOptions
            ? _c(
                "div",
                { staticClass: "mr-2" },
                [
                  _c("font-awesome-icon", {
                    staticClass: "mr-1 status-icon",
                    attrs: { icon: ["far", "palette"] },
                  }),
                ],
                1
              )
            : _c(
                "div",
                { staticClass: "icon mr-2 justify-start" },
                [
                  _c(
                    _setup.CLazy,
                    { staticClass: "d-flex items-center element-icon" },
                    [
                      _c(_setup.SvgIcon, {
                        attrs: { src: _setup.getElementIcon },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
          _vm._v(" "),
          _vm.item.element.type === "bounded-text" && _vm.item.element.useAsMask
            ? _c(
                "div",
                { staticClass: "icon mr-2 justify-start" },
                [
                  _c("font-awesome-icon", {
                    staticClass: "d-flex items-center element-icon",
                    attrs: { icon: ["far", "square-ring"] },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.item.element.type === "bounded-text" &&
          _vm.item.element.useAsCutout
            ? _c(
                "div",
                { staticClass: "icon mr-2 justify-start" },
                [
                  _c("font-awesome-icon", {
                    staticClass: "d-flex items-center element-icon",
                    attrs: { icon: ["fas", "square-a"] },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _setup.isMaskedImage
            ? _c(
                "div",
                { staticClass: "icon mr-2 justify-start" },
                [
                  _c("font-awesome-icon", {
                    staticClass: "d-flex items-center element-icon",
                    attrs: { icon: ["far", "circle-half-stroke"] },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "layers-element-title grow-1 d-flex align-items-center justify-content-between",
              class: {
                "not-visible": !_setup.isVisible,
              },
            },
            [
              _c(_setup.EditableText, {
                staticClass: "flex-fill",
                attrs: {
                  value: _vm.item.element.name || "",
                  "default-text": _setup.elementTitle,
                  "allow-editing": !_setup.flags?.readonly,
                },
                on: { input: _setup.onElementTitleChange },
              }),
              _vm._v(" "),
              _setup.showLinkButton
                ? _c(_setup.CButton, {
                    directives: [{ name: "tippy", rawName: "v-tippy" }],
                    staticClass: "link-btn color-gray-600",
                    class: {
                      "always-visible": !!_setup.selectedElement?.sourceElement,
                      "no-events":
                        _setup.isPreviewStep || _setup.flags?.readonly,
                    },
                    attrs: {
                      content: "Edit Link",
                      size: "sm",
                      icon: ["far", "link"],
                    },
                    on: { click: _setup.onLinkButtonClick },
                  })
                : _vm._e(),
              _vm._v(" "),
              _setup.showLinkModal
                ? _c(_setup.ElementsLinkModal, {
                    attrs: {
                      "target-element": _setup.selectedElement,
                      "source-elements": _setup.sources,
                    },
                    on: {
                      close: _setup.closeLinkModal,
                      applyLink: _setup.handleApplyLink,
                      unlink: _setup.handleUnlink,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      !_setup.flags?.readonly
        ? _c("div", { staticClass: "layer-shrink text-center" }, [
            _c("div", { staticClass: "user-select-none nowrap" }, [
              _vm._v("ID " + _vm._s(_vm.item.element.id)),
            ]),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }